import api from './api';

const authService = {
  register: (data) => api.post('/auth/register', data),

  login: (phone) => api.post('/auth/login', { phone }),

  verifyOtp: (phone, otp) => api.post('/auth/verify-otp', { phone, otp_code: otp }),

  refreshToken: (refreshToken) =>
    api.post('/auth/refresh', { refresh_token: refreshToken }),

  getProfile: () => api.get('/users/me'),

  updateProfile: (data) => api.patch('/users/me', data),

  changePhone: (newPhone) => api.post('/auth/change-phone', { phone: newPhone }),

  verifyPhoneChange: (otp) => api.post('/auth/verify-phone-change', { otp }),

  logout: () => api.post('/auth/logout'),
};

export default authService;
